import { render, staticRenderFns } from "./pedidos.vue?vue&type=template&id=4d4084cb&"
import script from "./pedidos.vue?vue&type=script&lang=ts&"
export * from "./pedidos.vue?vue&type=script&lang=ts&"
import style0 from "./pedidos.vue?vue&type=style&index=0&id=4d4084cb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports